export default function () {
  let triggers = document.querySelectorAll('.jsLightboxResourceTrigger');

  for (var i = 0; i < triggers.length; i++) {
    triggers[i].addEventListener('click', function (e) {
      e.preventDefault();
      let lightbox = document.querySelector('.jsLightboxResource');

      let target = this.dataset.target || '';
      let cta = lightbox.querySelector('.jsLightboxResourceCta')

      if (cta !== undefined && cta !== null) {
        cta.setAttribute('href', target);
      }

      lightbox.classList.toggle('lightbox-resource--visible');
    })
  }
}
